import { ChangeEvent, ReactElement, ReactNode, useState } from "react";
import { Tab, Tabs } from "@mui/material";
import ProductionTable from "./productionTable";
import ProductionTableDetail from "./productionTableDetail";
import ProductionTableGrouped from "./productionTableGrouped";
import { useSelector } from "react-redux";
import { IDictionaryNumericKey, IParentSize, IProduction, IState } from "../../../types";
import { IAuxiliaryData, IMillProductDetail } from "../types";
import ProductionQRTable from "./productionQRTable";
// import ProductionTableMechanicalTest from "./productionTableMechanicalTest";
import ProductionQRFanTable from "./productionQRFanTable";

interface IProps {
  productionData: IProduction[];
  productDetail: IMillProductDetail[];
  parentSize: IParentSize;
  auxiliaryData: IDictionaryNumericKey<IAuxiliaryData> | null;
}


interface ITabPanelProps {
  children?: ReactNode;
  index: any;
  value: any;
}

const a11yProps = (index: number): any => {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
};

function TabPanel(props: ITabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      className="flex-grow-1"
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
      style={{ height: "calc(100% - 48px)" }}>
      {value === index && children}
    </div>
  );
}


const ProductionTabPanel = ({ productionData, productDetail, auxiliaryData, parentSize }: IProps): ReactElement => {
  const darkMode = useSelector((state: IState) => state.darkMode);
  const [tabSelected, setTabSelected] = useState(0);


  const handleChange = (_event: ChangeEvent<any>, newValue: number) => {
    setTabSelected(newValue);
  };

  return (
    <div style={{ ...parentSize }}>
      <Tabs
        value={tabSelected}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        centered={true}
        style={{ background: darkMode ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.2)" }}>
        <Tab label="Orders" {...a11yProps(0)} />
        <Tab label="Billets" {...a11yProps(1)} />
        <Tab label="Grouped" {...a11yProps(2)} />
        <Tab label="Quality Rounds" {...a11yProps(3)} />
        <Tab label="Quality Rounds / FAN" {...a11yProps(4)} />
        {/*<Tab label="Mechanical Tests" {...a11yProps(4)} />*/}
      </Tabs>
      <TabPanel value={tabSelected} index={0} >
        <ProductionTable productionData={productionData} parentSize={{ ...parentSize, height: parentSize.height - 42 }} auxiliaryData={auxiliaryData}/>
      </TabPanel>
      <TabPanel value={tabSelected} index={1} >
        <ProductionTableDetail products={productDetail} parentSize={{ ...parentSize, height: parentSize.height - 42 }} />
      </TabPanel>
      <TabPanel value={tabSelected} index={2} >
        <ProductionTableGrouped products={productDetail} parentSize={{ ...parentSize, height: parentSize.height - 42 }} />
      </TabPanel>
      <TabPanel value={tabSelected} index={3} >
        <ProductionQRTable productionData={productionData} products={productDetail} parentSize={{ ...parentSize, height: parentSize.height - 42 }}/>
      </TabPanel>
      <TabPanel value={tabSelected} index={4} >
        <ProductionQRFanTable productionData={productionData} products={productDetail} parentSize={{ ...parentSize, height: parentSize.height - 42 }}/>
      </TabPanel>
      {/*<TabPanel value={tabSelected} index={5} >*/}
      {/*  <ProductionTableMechanicalTest/>*/}
      {/*</TabPanel>*/}
    </div>
  );
};

export default ProductionTabPanel;
